// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SchemaMigrations_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/schema_migrations/list — the dry-run
 * (same fields as SchemaMigrations_CheckResponse) plus the most recent ledger
 * rows, for the staff page /config/migracoes.
 */
import type { SchemaMigrations_FailureRow } from './SchemaMigrations_FailureRow'
import type { SchemaMigrations_LedgerRow } from './SchemaMigrations_LedgerRow'
import type { SchemaMigrations_MigrationRow } from './SchemaMigrations_MigrationRow'
import type { SchemaMigrations_ModelRow } from './SchemaMigrations_ModelRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SchemaMigrations_ListResponseDados {
outcome: string
total: number
pending: number
no_schema: number
models: SchemaMigrations_ModelRow[]
migrations: SchemaMigrations_MigrationRow[]
failures: SchemaMigrations_FailureRow[]
ledger: SchemaMigrations_LedgerRow[]
}

export type SchemaMigrations_ListResponse = ApiResponse<SchemaMigrations_ListResponseDados>;

registerResponseContract('SchemaMigrations_ListResponse', {
  outcome:    { type: 'string',  required: true },
  total:      { type: 'number',  required: true },
  pending:    { type: 'number',  required: true },
  no_schema:  { type: 'number',  required: true },
  models: {
    type: 'array',
    required: true,
    items: {
      model:           { type: 'string',  required: true },
      state:           { type: 'string',  required: true },
      table:           { type: 'string',  required: false },
      ddl:             { type: 'string',  required: false },
      fields_hash:     { type: 'string',  required: false },
      last_applied_at: { type: 'string',  required: false },
      hash_changed:    { type: 'boolean', required: false },
    },
  },
  migrations: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'string',  required: true },
      description:     { type: 'string',  required: true },
      state:           { type: 'string',  required: true },
      last_applied_at: { type: 'string',  required: false },
      ledger_only:     { type: 'boolean', required: false },
    },
  },
  failures: {
    type: 'array',
    required: true,
    items: {
      model: { type: 'string',  required: true },
      error: { type: 'string',  required: true },
      phase: { type: 'string',  required: false },
    },
  },
  ledger: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'string',  required: true },
      run_id:      { type: 'string',  required: true },
      kind:        { type: 'string',  required: true },
      subject:     { type: 'string',  required: true },
      fields_hash: { type: 'string',  required: false },
      ddl:         { type: 'string',  required: false },
      extra:       { type: 'string',  required: true },
      duration_ms: { type: 'string',  required: true },
      actor:       { type: 'string',  required: true },
      applied_at:  { type: 'string',  required: true },
    },
  },
})
